import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from '../../../../src/client/App'

import createAuthRequiredPage from "./auth/pages/createAuthRequiredPage"

import LandingPage from '../../../../src/landing-page/LandingPage'
import BlogListPage from '../../../../src/blog/BlogListPage'
import BlogPostPage from '../../../../src/blog/BlogPostPage'
import ComparatorPage from '../../../../src/comparator/ComparatorPage'
import HelpPage from '../../../../src/help/HelpPage'
import LoginPage from '../../../../src/auth/LoginPage'
import { Signup as SignupPage } from '../../../../src/auth/SignupPage'
import { RequestPasswordResetPage } from '../../../../src/auth/email-and-pass/RequestPasswordResetPage'
import { PasswordResetPage } from '../../../../src/auth/email-and-pass/PasswordResetPage'
import { EmailVerificationPage } from '../../../../src/auth/email-and-pass/EmailVerificationPage'
import AccountPage from '../../../../src/user/AccountPage'
import { JournalRoute as TradingJournalPage } from '../../../../src/lite/routes'
import { AnalyticsRoute as TradingAnalyticsPage } from '../../../../src/lite/routes'
import TradeDetailPage from '../../../../src/trading-journal/TradeDetailPage'
import { AccountsRoute as TradingAccountsPage } from '../../../../src/lite/routes'
import { PlaybookRoute as PlaybookPage } from '../../../../src/lite/routes'
import { PropFirmManagerRoute as PropFirmManagerPage } from '../../../../src/lite/routes'
import { AccountDetailRoute as AccountDetailPage } from '../../../../src/lite/routes'
import AccountGroupDetailPage from '../../../../src/trading-accounts/AccountGroupDetailPage'
import { EdgyReportsRoute as EdgyReportsPage } from '../../../../src/lite/routes'
import { ReportsRoute as ReportsPage } from '../../../../src/lite/routes'
import { ReportDetailRoute as ReportDetailPage } from '../../../../src/lite/routes'
import RedirectToRoutinesPage from '../../../../src/discipline-manager/RedirectToRoutines'
import RedirectToGoalsPage from '../../../../src/discipline-manager/RedirectToGoals'
import RedirectToNotebookPage from '../../../../src/discipline-manager/RedirectToNotebook'
import RedirectToNotebookNotePage from '../../../../src/discipline-manager/RedirectToNotebookNote'
import FundamentalAnalysisRedirectPage from '../../../../src/fundamental-analysis/FundamentalAnalysisPage'
import { TradingSessionsRoute as TradingSessionsPage } from '../../../../src/lite/routes'
import { SessionDetailRoute as SessionDetailPage } from '../../../../src/lite/routes'
import SessionSharePage from '../../../../src/trading-sessions/SessionSharePage'
import { DashboardRoute as TradingDashboardPage } from '../../../../src/lite/routes'
import LayoutSharePreviewPage from '../../../../src/dashboard/LayoutSharePreviewPage'
import CustomPagePage from '../../../../src/custom-pages/CustomPageView'
import AboutPage from '../../../../src/legal/AboutPage'
import AffiliationPage from '../../../../src/affiliate/AffiliationLandingPage'
import AffiliatePage from '../../../../src/affiliate/AffiliatePage'
import PrivacyPage from '../../../../src/legal/PrivacyPage'
import TermsPage from '../../../../src/legal/TermsPage'
import DisclosuresPage from '../../../../src/legal/DisclosuresPage'
import JournalDeTradingPage from '../../../../src/marketing/pages/JournalDeTradingPage'
import FeaturePropFirmManagerPage from '../../../../src/marketing/pages/FeaturePropFirmManagerPage'
import FeatureAnalyticsPage from '../../../../src/marketing/pages/FeatureAnalyticsPage'
import FeatureSessionsPage from '../../../../src/marketing/pages/FeatureSessionsPage'
import FeatureMentorPage from '../../../../src/marketing/pages/FeatureMentorPage'
import FeatureDashboardPage from '../../../../src/marketing/pages/FeatureDashboardPage'
import IntegrationsPage from '../../../../src/marketing/pages/IntegrationsPage'
import SolutionDebutantPage from '../../../../src/marketing/pages/SolutionDebutantPage'
import SolutionMultiComptesPage from '../../../../src/marketing/pages/SolutionMultiComptesPage'
import SolutionCoachPage from '../../../../src/marketing/pages/SolutionCoachPage'
import VsTradeZellaPage from '../../../../src/marketing/pages/VsTradeZellaPage'
import VsTraderSyncPage from '../../../../src/marketing/pages/VsTraderSyncPage'
import VsNotionPage from '../../../../src/marketing/pages/VsNotionPage'
import VsExcelPage from '../../../../src/marketing/pages/VsExcelPage'
import BestJournalPage from '../../../../src/marketing/pages/BestJournalPage'
import AlternativesPage from '../../../../src/marketing/pages/AlternativesPage'
import PricingPage from '../../../../src/marketing/pages/PricingPage'
import CheckoutResultPage from '../../../../src/payment/CheckoutResultPage'
import FileUploadPage from '../../../../src/file-upload/FileUploadPage'
import AnalyticsDashboardPage from '../../../../src/admin/dashboards/analytics/AnalyticsDashboardPage'
import AdminUsersPage from '../../../../src/admin/dashboards/users/UsersDashboardPage'
import { NotFoundPage } from '../../../../src/client/components/NotFoundPage'
import AdminMessagesPage from '../../../../src/admin/dashboards/messages/MessagesPage'
import AdminPropFirmsPage from '../../../../src/admin/dashboards/propfirms/AdminPropFirmsPage'
import AdminBlogPage from '../../../../src/admin/dashboards/blog/AdminBlogPage'
import AdminComparatorPage from '../../../../src/admin/dashboards/comparator/AdminComparatorPage'
import AdminAffiliatesPage from '../../../../src/admin/dashboards/affiliates/AdminAffiliatesPage'
import AdminB2bPage from '../../../../src/admin/dashboards/b2b/AdminB2bPage'
import AdminBlogEditPage from '../../../../src/admin/dashboards/blog/AdminBlogEditPage'
import AdminBlogCategoriesPage from '../../../../src/admin/dashboards/blog/AdminBlogCategoriesPage'
import AdminHelpCategoriesPage from '../../../../src/admin/dashboards/help/AdminHelpCategoriesPage'
import AdminHelpPage from '../../../../src/admin/dashboards/help/AdminHelpPage'
import AdminHelpItemEditPage from '../../../../src/admin/dashboards/help/AdminHelpItemEditPage'
import AdminLayoutsPage from '../../../../src/admin/dashboards/layouts/AdminLayoutsPage'
import MentorDashboardPage from '../../../../src/mentor/MentorDashboardPage'
import StudentOverviewPage from '../../../../src/mentor/StudentOverviewPage'
import StudentJournalPage from '../../../../src/mentor/StudentJournalPage'
import StudentDashboardPage from '../../../../src/mentor/StudentDashboardPage'
import StudentAnalyticsPage from '../../../../src/mentor/StudentAnalyticsPage'
import StudentSessionsPage from '../../../../src/mentor/StudentSessionsPage'
import StudentSessionDetailPage from '../../../../src/mentor/StudentSessionDetailPage'
import StudentPropFirmPage from '../../../../src/mentor/StudentPropFirmPage'
import AcceptInvitationPage from '../../../../src/mentor/AcceptInvitationPage'
import { DisciplineRoute as DisciplineManagerPage } from '../../../../src/lite/routes'


import { DefaultRootErrorBoundary } from './components/DefaultRootErrorBoundary'

import { routes } from 'wasp/client/router'

export const routeNameToRouteComponent = {
  LandingPageRoute: LandingPage,
  BlogListRoute: BlogListPage,
  BlogPostRoute: BlogPostPage,
  ComparatorRoute: ComparatorPage,
  HelpRoute: HelpPage,
  LoginRoute: LoginPage,
  SignupRoute: SignupPage,
  RequestPasswordResetRoute: RequestPasswordResetPage,
  PasswordResetRoute: PasswordResetPage,
  EmailVerificationRoute: EmailVerificationPage,
  AccountRoute: createAuthRequiredPage(AccountPage),
  TradingJournalRoute: createAuthRequiredPage(TradingJournalPage),
  TradingAnalyticsRoute: createAuthRequiredPage(TradingAnalyticsPage),
  TradeDetailRoute: createAuthRequiredPage(TradeDetailPage),
  TradingAccountsRoute: createAuthRequiredPage(TradingAccountsPage),
  PlaybookRoute: createAuthRequiredPage(PlaybookPage),
  PropFirmManagerRoute: createAuthRequiredPage(PropFirmManagerPage),
  AccountDetailRoute: createAuthRequiredPage(AccountDetailPage),
  AccountGroupDetailRoute: createAuthRequiredPage(AccountGroupDetailPage),
  EdgyReportsRoute: createAuthRequiredPage(EdgyReportsPage),
  ReportsRoute: createAuthRequiredPage(ReportsPage),
  ReportDetailRoute: createAuthRequiredPage(ReportDetailPage),
  TradingRoutinesRoute: createAuthRequiredPage(RedirectToRoutinesPage),
  TradingGoalsRoute: createAuthRequiredPage(RedirectToGoalsPage),
  NotebookRoute: createAuthRequiredPage(RedirectToNotebookPage),
  NotebookNoteRoute: createAuthRequiredPage(RedirectToNotebookNotePage),
  FundamentalAnalysisRoute: createAuthRequiredPage(FundamentalAnalysisRedirectPage),
  TradingSessionsRoute: createAuthRequiredPage(TradingSessionsPage),
  SessionDetailRoute: createAuthRequiredPage(SessionDetailPage),
  SessionShareRoute: SessionSharePage,
  TradingDashboardRoute: createAuthRequiredPage(TradingDashboardPage),
  LayoutSharePreviewRoute: LayoutSharePreviewPage,
  CustomPageRoute: createAuthRequiredPage(CustomPagePage),
  AboutPageRoute: AboutPage,
  AffiliationRoute: AffiliationPage,
  AffiliateRoute: createAuthRequiredPage(AffiliatePage),
  PrivacyPageRoute: PrivacyPage,
  TermsPageRoute: TermsPage,
  DisclosuresPageRoute: DisclosuresPage,
  JournalDeTradingRoute: JournalDeTradingPage,
  FeaturePropFirmManagerRoute: FeaturePropFirmManagerPage,
  FeatureAnalyticsRoute: FeatureAnalyticsPage,
  FeatureSessionsRoute: FeatureSessionsPage,
  FeatureMentorRoute: FeatureMentorPage,
  FeatureDashboardRoute: FeatureDashboardPage,
  IntegrationsRoute: IntegrationsPage,
  SolutionDebutantRoute: SolutionDebutantPage,
  SolutionMultiComptesRoute: SolutionMultiComptesPage,
  SolutionCoachRoute: SolutionCoachPage,
  VsTradeZellaRoute: VsTradeZellaPage,
  VsTraderSyncRoute: VsTraderSyncPage,
  VsNotionRoute: VsNotionPage,
  VsExcelRoute: VsExcelPage,
  BestJournalRoute: BestJournalPage,
  AlternativesRoute: AlternativesPage,
  PricingRoute: PricingPage,
  CheckoutResultRoute: createAuthRequiredPage(CheckoutResultPage),
  FileUploadRoute: createAuthRequiredPage(FileUploadPage),
  AdminRoute: createAuthRequiredPage(AnalyticsDashboardPage),
  AdminUsersRoute: createAuthRequiredPage(AdminUsersPage),
  NotFoundRoute: NotFoundPage,
  AdminMessagesRoute: createAuthRequiredPage(AdminMessagesPage),
  AdminPropFirmsRoute: createAuthRequiredPage(AdminPropFirmsPage),
  AdminBlogRoute: createAuthRequiredPage(AdminBlogPage),
  AdminComparatorRoute: createAuthRequiredPage(AdminComparatorPage),
  AdminAffiliatesRoute: createAuthRequiredPage(AdminAffiliatesPage),
  AdminB2bRoute: createAuthRequiredPage(AdminB2bPage),
  AdminBlogNewRoute: createAuthRequiredPage(AdminBlogEditPage),
  AdminBlogEditRoute: createAuthRequiredPage(AdminBlogEditPage),
  AdminBlogCategoriesRoute: createAuthRequiredPage(AdminBlogCategoriesPage),
  AdminHelpRoute: createAuthRequiredPage(AdminHelpCategoriesPage),
  AdminHelpQuestionsRoute: createAuthRequiredPage(AdminHelpPage),
  AdminHelpNewRoute: createAuthRequiredPage(AdminHelpItemEditPage),
  AdminHelpEditRoute: createAuthRequiredPage(AdminHelpItemEditPage),
  AdminLayoutsRoute: createAuthRequiredPage(AdminLayoutsPage),
  MentorDashboardRoute: createAuthRequiredPage(MentorDashboardPage),
  StudentOverviewRoute: createAuthRequiredPage(StudentOverviewPage),
  StudentJournalRoute: createAuthRequiredPage(StudentJournalPage),
  StudentDashboardRoute: createAuthRequiredPage(StudentDashboardPage),
  StudentAnalyticsRoute: createAuthRequiredPage(StudentAnalyticsPage),
  StudentSessionsRoute: createAuthRequiredPage(StudentSessionsPage),
  StudentSessionDetailRoute: createAuthRequiredPage(StudentSessionDetailPage),
  StudentPropFirmRoute: createAuthRequiredPage(StudentPropFirmPage),
  AcceptInvitationRoute: AcceptInvitationPage,
  DisciplineManagerRoute: createAuthRequiredPage(DisciplineManagerPage),
  DisciplineManagerNoteRoute: createAuthRequiredPage(DisciplineManagerPage),
} as const;

const waspDefinedRoutes = [
]
const userDefinedRoutes = Object.entries(routes).map(([routeKey, route]) => {
  return {
    path: route.to,
    Component: routeNameToRouteComponent[routeKey],
  }
})

const browserRouter = createBrowserRouter([{
  path: '/',
  element: <App />,
  ErrorBoundary: DefaultRootErrorBoundary,
  children: [
    ...waspDefinedRoutes,
    ...userDefinedRoutes,
  ],
}], {
  basename: '/',
})

export const router = <RouterProvider router={browserRouter} />
